const AREAS = [
  "Palm Bay",
  "Melbourne",
  "Viera / Suntree",
  "Cocoa & Rockledge",
  "Titusville",
  "Merritt Island",
  "Satellite Beach",
  "Indialantic & Beaches",
];

export default function ServiceArea() {
  return (
    <section id="service-area" data-testid="service-area-section" className="py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 space-y-6">
          <h2 className="text-3xl sm:text-5xl font-black uppercase tracking-tighter font-display text-white">
            Serving All of Brevard County
          </h2>
          <p className="text-zinc-400 text-sm sm:text-base leading-relaxed">
            Headquartered in Palm Bay, FL, our trucks cover North, Central, and South Brevard every single day.
          </p>

          <div className="grid grid-cols-2 gap-3 text-xs font-mono text-zinc-300 pt-2">
            {AREAS.map((a) => (
              <div key={a} className="p-3 rounded-lg bg-zinc-950 border border-zinc-800">✓ {a}</div>
            ))}
          </div>

          <div className="p-4 rounded-xl bg-zinc-950 border border-white/20 flex items-center justify-between">
            <div>
              <div className="text-xs font-mono text-zinc-400">Headquarters & Depot</div>
              <div className="text-sm font-bold text-white uppercase">Palm Bay, FL · Serving Brevard County</div>
            </div>
            <span className="text-xs font-mono bg-white text-black px-2.5 py-1 rounded font-bold">FL Dispatch</span>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="w-full aspect-[16/10] rounded-2xl border border-zinc-800 bg-zinc-950 p-6 flex flex-col justify-between relative overflow-hidden">
            <div className="absolute inset-0 bg-neutral-900/60 truck-pattern opacity-50" />
            <div className="relative z-10 flex justify-between items-start gap-3 flex-wrap">
              <span className="px-3 py-1 bg-black/90 border border-zinc-700 text-[11px] font-mono text-zinc-300 rounded uppercase">
                Brevard County Florida Operations Zone
              </span>
              <span className="text-xs font-mono text-zinc-300">Daily Truck Routes Active</span>
            </div>
            <div className="relative z-10 py-8 text-center">
              <div className="text-2xl sm:text-3xl font-black text-white uppercase font-display tracking-tight">
                PALM BAY • MELBOURNE • SPACE COAST
              </div>
              <p className="text-xs font-mono text-zinc-300 mt-2">Truck routes staged along I-95 & US-1 corridors</p>
            </div>
            <div className="relative z-10 flex justify-between items-end gap-3 flex-wrap text-xs font-mono text-zinc-400 border-t border-zinc-800/80 pt-3">
              <span>Direct Dispatch: (321) 420-2707</span>
              <span>Same-Day Routing Available</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
